
import React, { Suspense } from 'react';
import Spinner from '../../components/spinner';
// Lazy-loaded components
const OccupationalTherapyPageHeaderession = React.lazy(() => import('../departments/occupationaltherapy/OccupationalTherapyPageSession'));
const OccupationalTherapyPageHeader = React.lazy(() => import('../departments/occupationaltherapy/OccupationalTherapyPageHeader'));

function OccupationalTherapyPage() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />} jsx={true.toString()}>
       <OccupationalTherapyPageHeader />
       <OccupationalTherapyPageHeaderession />
      </Suspense>
    </div>
  );
}

export default OccupationalTherapyPage;
